import { Stack } from '@mui/material'
import { useRegisterSubFormStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router'
import { RailVisitFormStore } from '../../stores/RaillVisitFormStore'
import { RailVisitCargoFormStore } from '../../stores/RailVisitCargoFormStore'
import { RailVisitGeneralInformationFormStore } from '../../stores/RailVisitGeneralInformationFormStore'
import { RailVisitTrackAndTimingFormStore } from '../../stores/RailVisitTrackAndTimingFormStore'
import { RailVisitCargoControlCard } from '../Organisms/Cargo/RailVisitCargoControlCard'
import { RailVisitGeneralInformationControlCard } from '../Organisms/GeneralInformation/RailVisitGeneralInformationControlCard'
import { RailVisitTrackAndTimingControlCard } from '../Organisms/TrackAndTimings/RailVisitTrackAndTimingControlCard'

interface Props {
  formStore: RailVisitFormStore
  allowEdit?: boolean
  hideActions?: boolean
}
export const RailVisitForm = observer((props: Props) => {
  const { id } = useParams()
  const { formStore, allowEdit } = props
  const { generalInformation, cargo, trackAndTiming } = formStore.initialValues

  const railVisitGeneralInformationFormStore = useRegisterSubFormStore(
    formStore,
    'generalInformation',
    new RailVisitGeneralInformationFormStore(generalInformation),
  )

  const railVisitCargoFormStore = useRegisterSubFormStore(
    formStore,
    'cargo',
    new RailVisitCargoFormStore(cargo),
  )

  const railVisitTrackAndTimingFormStore = useRegisterSubFormStore(
    formStore,
    'trackAndTiming',
    new RailVisitTrackAndTimingFormStore(trackAndTiming),
  )

  const isEditMode = !!id

  return (
    <form autoComplete='off'>
      <Stack gap={2}>
        <RailVisitGeneralInformationControlCard
          {...props}
          isEditMode={isEditMode}
          railVisitGeneralInformationFormStore={railVisitGeneralInformationFormStore}
        />
        <RailVisitCargoControlCard
          {...props}
          isEditMode={isEditMode}
          railVisitCargoFormStore={railVisitCargoFormStore}
        />
        <RailVisitTrackAndTimingControlCard
          {...props}
          isEditMode={isEditMode}
          railVisitTrackAndTimingFormStore={railVisitTrackAndTimingFormStore}
        />
      </Stack>
    </form>
  )
})
